import EventTracking from 'tc-event-tracking';

import { getCurrentDevice, isValidDate, $win, keys, dynamizeLocales, dynamizeWeekdays } from './utils';
import moment from 'moment';
import 'lazysizes';

import slidersUI from './sliders';
import adaUI from './ada';
import shaveUI from './shave-ui';
import readMoreUI from './read-more-ui';
import mapsUI from './maps-ui';
import heroUI from './hero-ui';
import qtyUI from './qtyUI';
import bmUI from './bmUI';
import headerUI from './headerUI';
import navsUI from './navsUI';
import AOS from 'aos';
import itemsUI from './items-ui';
import selectsUI from './selectsUI';
import cookiesUI from './cookies-ui';
import initBookingMask from './BookingMask';
import initMapsLinks from './mapsLinks';
import disableHover from './disable-hover';
import formatDates from './formatDate';
import personalizationUI from './modules/personalizationUI';
import yearsChecksUI from './yearsChecksUI';
import initGMS from './modules/gms';
import gmsOffers from './modules/gms-offers';
import gmsRedirectAfterLogin from './modules/gms-redirect-after-login';
import tooltipUi from './tooltip-ui';
import initJSONStatic from './modules/json-static-block';

;(function(window, document, $) {
	EventTracking.init();

	/* KEEP BEFORE EVERYTHING ELSE */
	gmsRedirectAfterLogin();
	initGMS();
	gmsOffers();

	/* First thing to do, to avoid having videos autoplaying */
	$('.js-slider-highlight-images iframe[src*="&autoplay=true"]').each((index, el) => {
		let src = $(el).attr('src');
		$(el).attr('src', src.replace('&autoplay=true','')).addClass('shouldAutoPlay');
	});

	if ( $('.js-home').length ) {
		$('.js-home').attr('href', $('.js-logo-home').first().attr('href'));
	}
	
	$('a[href^="tel"]').each(function() {
		const linkHref = $(this).attr('href');
		$(this).attr('href', linkHref.replace(/ /igm, ''));
	});

	$('.js-back-to-top').on('click', function(event) {
		event.preventDefault();

		$('html, body').animate({
			scrollTop: 0
		}, 1000);
	});

	$(`a[href="${document.location.pathname}"]`).addClass('current');

	if (window.location.hash) {
		const hash = window.location.hash;

		$(`[href="${hash}"],[data-target="${hash}"]`).trigger('click');
	}

	if ($win.width() > 1024) $('.detach-desktop').remove();
	else $('.detach-mobile').remove();

	/* When using site search 360,
	make sure to close the modal to avoid a bug where it's not possible
	to focus the input in sitesearch
	this is because when a modal is open, bootstrap for ADA must control the focus I guess */
	$('.js-ss360-trigger').on('click', function() {
		$(this).closest('.modal-navigation').modal('hide')
	});

	/* Blocks that are relying on JSON data to be displayed */
	initJSONStatic({
		callback(el) {
			slidersUI(el);

			formatDates(el);

			shaveUI(el);

			setTimeout(function() {
				AOS.refreshHard();
			}, 1000);
		}
	});

	personalizationUI();

	$('.js-move').each(function() {
		const $this = $(this);
		const $target = $($this.data('target'));
		const mobileOnly = $this.data('mobile') ? $this.data('mobile') : false;

		if ( mobileOnly ) {
			if ( getCurrentDevice() == 'mobile' ) {
				setTimeout(() => {
					$target.append($this);
				}, 50);
			}
		} else {
			$target.append($this);
		}

	});

	yearsChecksUI();

	formatDates();

	tooltipUi();

	headerUI();

	navsUI();

	selectsUI();

	heroUI();

	slidersUI();

	adaUI();

	shaveUI();

	readMoreUI();

	mapsUI();

	qtyUI();

	bmUI();

	itemsUI();

	cookiesUI();

	initMapsLinks();

	AOS.init({
		duration: 700,
		easing: 'ease-in-cubic',
		offset: 50,
		once: true
	});

	$win.on('load', function() {
		AOS.refresh()
	});

	$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
		setTimeout(() => {
			AOS.refresh();
		}, 100);
	})

	initBookingMask();

	disableHover();
	
	if ($('.js-benefits-table').length) {
		import(/* webpackChunkName: "benefitsTableUI" */ './benefits-table-ui').then(module => {
			module.default();
		});
	}

	if ($('.js-modal-datepickers').length) {
		import(/* webpackChunkName: "datepickersUI" */ './datepickersUI').then(module => {
			module.default();
		});
	}

	if ($('.js-datepickers').length || $('.js-datepicker-single').length) {
		import(/* webpackChunkName: "datepickersDefaultUI" */ './datepickers-default-ui').then(module => {
			module.default();
		});
	}

	if ($('.js-custom-field').length) {
		import(/* webpackChunkName: "toggleFormsState" */ './form-active-state').then(module => {
			module.default();
		});
	}

	if ($('.js-form').length) {
		import(/* webpackChunkName: "formsUI" */ './forms-ui').then(module => {
			module.default();
		});
	}

	if ($('.js-events-next-prev').length) {
		import(/* webpackChunkName: "paginationUI" */ './paginationUI').then(module => {
			module.default();
		});
	}

	if ($('.js-open-gallery').length || $('.modal-images').length) {
		import(/* webpackChunkName: "popupUI" */ './popupUI').then(module => {
			module.default();
		});
	}

	if ($('.js-filters').length) {
		import(/* webpackChunkName: "filtersUI" */ './filtersUI').then(module => {
			module.default();
		});
	}

	if ($('.js-module-dynamic').length) {
		import(/* webpackChunkName: "dynamicData" */ './modules/dynamic-data').then(module => {
			module.default();
		});
	}
})(window, document, window.jQuery);
